import { render, staticRenderFns } from "./SynthesisImg.vue?vue&type=template&id=0711ffde"
import script from "./SynthesisImg.vue?vue&type=script&lang=js"
export * from "./SynthesisImg.vue?vue&type=script&lang=js"
import style0 from "./SynthesisImg.vue?vue&type=style&index=0&id=0711ffde&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports